export default __webpack_public_path__ + "img/caret-down-grey.811df8b6.svg";